import Paper from "@mui/material/Paper/Paper";
import Divider from "@mui/material/Divider/Divider";
import Grid from "@mui/material/Grid/Grid";
import Typography from "@mui/material/Typography/Typography";
import makeStyles from "@mui/styles/makeStyles/makeStyles";

const useStyles = makeStyles(() => ({
  card: {
    width: "100%",
    borderRadius: "10px",
    marginBottom: "4vh",
  },
  cardTitle: {
    marginInline: "4vh",
    marginTop: "4vh",
    marginBottom: "4vh",
    fontWeight: "700",
    fontSize: "1.75vh",
    color: "#5C5C5C",
  },
  overflowText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "100%", // You can adjust this to your desired width
    paddingInline: "0.5vw",
  },
}));

const CompanyRankComponent = ({ counters }) => {
  const classes = useStyles();

  const Row = ({ position, company, quantity, isHeader }) => {
    return (
      <Paper
        variant="outlined"
        style={{
          display: "flex",
          justifyContent: "space-between",
          paddingInline: "1vw",
          marginBottom: "1vh",
        }}
      >
        <Typography style={{ fontWeight: isHeader ? "bold" : "normal" }}>
          {position}
        </Typography>
        <Typography
          className={classes.overflowText}
          style={{ fontWeight: isHeader ? "bold" : "normal" }}
        >
          {company}
        </Typography>
        <Typography style={{ fontWeight: isHeader ? "bold" : "normal" }}>
          {quantity}
        </Typography>
      </Paper>
    );
  };

  return (
    <Paper variant="outlined" className={classes.card}>
      <Typography className={classes.cardTitle}>
        PRODUTOS COM MAIS ADESÃO
      </Typography>
      <Divider />
      <div style={{ marginBottom: "1vh", padding: "1vh" }}>
        <Grid container spacing={4}>
          <Grid item xs={4}>
            <Paper variant="outlined" style={{ padding: "1vh" }}>
              <Row
                position=""
                company="LINKS COPIADOS"
                quantity=""
                isHeader={true}
              />
              <Row
                position="POSIÇÃO"
                company="CAMPANHA"
                quantity="QUANTIDADE"
                isHeader={true}
              />
              {(counters?.produtosComMaisAdesao.linksCopiados ?? []).map(
                (item, i) => {
                  return (
                    <Row
                      key={i}
                      position={i + 1 + "º"}
                      company={item.nomeProduto}
                      quantity={parseFloat(item.links_copiados)}
                    />
                  );
                }
              )}
            </Paper>
          </Grid>
          <Grid item xs={4}>
            <Paper variant="outlined" style={{ padding: "1vh" }}>
              <Row
                position=""
                company="LINKS SOLICITADOS"
                quantity=""
                isHeader={true}
              />
              <Row
                position="POSIÇÃO"
                company="CAMPANHA"
                quantity="QUANTIDADE"
                isHeader={true}
              />
              {(counters?.produtosComMaisAdesao.linksSolicitados ?? []).map(
                (item, i) => {
                  return (
                    <Row
                      key={i}
                      position={i + 1 + "º"}
                      company={item.nomeProduto}
                      quantity={parseFloat(item.solicitacoes)}
                    />
                  );
                }
              )}
            </Paper>
          </Grid>
          <Grid item xs={4}>
            <Paper variant="outlined" style={{ padding: "1vh" }}>
              <Row
                position=""
                company="LINKS CONVERTIDOS"
                quantity=""
                isHeader={true}
              />
              <Row
                position="POSIÇÃO"
                company="CAMPANHA"
                quantity="QUANTIDADE"
                isHeader={true}
              />
              {(counters?.produtosComMaisAdesao.linksConvertidos ?? []).map(
                (item, i) => {
                  return (
                    <Row
                      key={i}
                      position={i + 1 + "º"}
                      company={item.nomeProduto}
                      quantity={parseFloat(item.producoes)}
                    />
                  );
                }
              )}
            </Paper>
          </Grid>
        </Grid>
      </div>
    </Paper>
  );
};

export default CompanyRankComponent;
